export const urlReplacement = (oldURL) =>
  encodeURI(oldURL)?.replace(/%5C/g, "/");
